enum cellType {
  Date,
  PaymentMethod,
  MultiText,
  TransactionType,
  Receipt,
  Notes,
  Menu,
  Status,
  Supported,
  PaymentWithType,
  Amount,
  SupportedWithIsraeliID,
  Number,
  String,
  CommentWithRightIcon,
  Selection,
  TruncatedList,
  Balance,
}

export default cellType;
